var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rubric-preview-tab"},[(_vm.rubric)?_c('rubric-form',{attrs:{"rubric":_vm.rubric,"editing":false,"hide-actions":true,"preview-mode":""}}):_c('div',{staticClass:"preview-placeholder"},[_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t("rubrics.noRubricPreview")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }